export const formatPhoneNumber = (phoneNumber: string) => {
  return `+48 ${phoneNumber.substr(1, 3)} ${phoneNumber.substr(
    3,
    3
  )} ${phoneNumber.substr(6, 3)}`;
};
